import { makeAutoObservable } from "mobx";
import { SearchServiceTreatment } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import {
  getServiceRequestItemById,
  pagingServiceRequestItem,
} from "app/services/ServiceRequestItemService";
import {
  getDiagnosticReportWithImages,
  getDiagnosticResultWithImages,
  saveDiagnosticReportImages,
  saveDiagnosticResultImages,
} from "app/services/DiagnosticReportImageResultService";
import i18n from "i18n";
import {
  getByServiceRequestItemId,
  getDiagnosticReportWithMaterialStandardsBySriId,
  getOrCreateNewByServiceRequestItemId,
  markMultipleServiceAsCompletedByServiceRequestItem,
  markServiceAsCompletedByServiceRequestItem,
  saveDiagnosticReportByServiceRequestItem,
  saveDiagnosticReportWithMaterialStandards,
  undoCreateNewDiagnosticReportByServiceRequestItemId,
  undoMarkServiceAsCompletedByServiceRequestItem,
} from "app/services/DiagnosticReportService";
import {
  getFileById,
  uploadFile,
} from "../../services/FileDescriptionExtService";
import {
  getPatientInfo,
  getPatientOverviewById,
} from "app/services/PatientService";
import { Customer } from "app/common/Model/Customer";
import history from "../../../history";
import Config from "../../appConfig";
import {
  LAServiceRequestItemStatusEnum,
  PathModule,
} from "app/common/LocalConst";
import moment from "moment";

const DEFAULT_VALUE_PATIENT = {
  patientInfo: new Customer(),
  checkinList: [],
  patientAdviceList: [],
};

export default class ReceiveTreatmentStore {
  intactSearchObject = {
    ...new SearchServiceTreatment(),
    pageIndex: 1,
    pageSize: 10,

    receptionTimeFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
      0,
      0,
      0,
      0
    ),
    receptionTimeTo: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
      23,
      59,
      59,
      999
    ),

    orderDateFrom: null,
    orderDateTo: null,

    performDateFrom: null, // Thời gian thực hiện từ
    performDateTo: null, // Thời gian thực hiện đến
    room: null, // Phòng thực hiện
    department: null, // Cơ sở thực hiện
    healthCareSv: null, //id cua dich vu
    findPerformerInSteps: true,
    performer: null,
    isOnProcess: true,
  };

  searchObject = { ...this.intactSearchObject };
  totalElements = 0;
  totalPages = 0;
  listTreatment = [];
  listChosen = [];
  resetSelectedRows = false;
  receiveTreatmentResult = null;
  onViewServiceRequestItem = null;
  openConfirmComplete = false;
  openConfirmCompleteList = false;
  diagnosticReportMaterialStandard = null;
  selectedFiles = [];
  shouldUploadFileResult = false;
  stepId = null;
  openConfirmMessage = null;
  permissionErrorMessage = null;
  listImageStep = [];
  shouldListImageStep = false;
  currentTab = 0;
  initialPatient = {
    ...DEFAULT_VALUE_PATIENT,
  };
  openConfirmUndoStartTreatment = false;

  constructor() {
    makeAutoObservable(this);
  }

  setSelectedRowTreatmentList = (row) => {
    this.listChosen = row;
  };

  setResetSelectedRows = (boolean) => {
    this.resetSelectedRows = boolean;
  };

  resetStore = () => {
    this.searchObject = JSON.parse(JSON.stringify(this.intactSearchObject));
    this.totalElements = 0;
    this.totalPages = 0;
    this.listTreatment = [];
    this.selectedTreatment = null;
    this.openConfirmDeletePopup = false;
    this.listChosen = [];
    this.openConfirmComplete = false;
    this.openConfirmCompleteList = false;
    this.resetSelectedRows = false;
    this.diagnosticReportMaterialStandard = null;
    this.shouldUploadFileResult = false;
    this.stepId = null;
    this.listImageStep = [];
    this.shouldListImageStep = false;
    this.currentTab = 0;
    this.openConfirmUndoStartTreatment = false;
    this.openConfirmUndoCompletedTreatment = false;
  };

  mapTabToStatus = (tab) => {
    // tab 1 => Mới chỉ định
    if (tab == 0) return 1;
    // tab 2 => Đã tiếp nhận
    if (tab == 1) return 2;
    // tab 2 => Đang thực hiện
    if (tab == 2) return 3;
    // tab 3 => Đã hoàn thành
    if (tab == 3) return 4;

    return null;
  };

  setCurrentTab = (tab) => {
    this.currentTab = tab;
  };

  pagingTreatments = async () => {
    let { healthCareSv, department, room, assigner, performer, ...ortherData } =
      this.searchObject;

    if (healthCareSv) {
      ortherData.healthCareSvId = healthCareSv?.id;
    }
    if (department) {
      ortherData.departmentId = department?.id;
    }
    if (room) {
      ortherData.roomId = room?.id;
    }
    if (assigner) {
      ortherData.assignerId = assigner?.id;
    }
    if (performer) {
      ortherData.performerId = performer?.id;
    }

    try {
      const payload = {
        ...ortherData,
        itemStatus: this.mapTabToStatus(this.searchObject?.itemStatus),
      };
      const data = await pagingServiceRequestItem(payload);

      this.listTreatment = data.data.content;
      this.totalElements = data.data.totalElements;
      this.totalPages = data.data.totalPages;
    } catch (error) {
      console.error(error);
      toast.error(i18n.t("toast.error"));
    }
  };

  handleFilter = (values) => {
    const newSearchObject = {
      ...values,
      pageIndex: 1,
    };

    this.searchObject = { ...this.searchObject, ...newSearchObject };
    this.pagingTreatments();
  };

  setPageIndex = async (page) => {
    this.searchObject.pageIndex = page;

    await this.pagingTreatments();
  };

  setPageSize = async (pageSize) => {
    this.searchObject.pageSize = pageSize;
    this.searchObject.pageIndex = 1;

    await this.pagingTreatments();
  };

  handleChangePage = async (newPage) => {
    await this.setPageIndex(newPage);
  };

  handleClose = () => {
    this.openConfirmDeletePopup = false;
    this.listChosen = [];
    this.openConfirmComplete = false;
    this.openConfirmCompleteList = false;
    this.shouldUploadFileResult = false;
    this.shouldListImageStep = false;
    this.openConfirmUndoStartTreatment = false;
    this.openConfirmUndoCompletedTreatment = false;
    this.openConfirmMessage = null;
    this.permissionErrorMessage = null;
  };

  getOnViewServiceRequestItem = async (sriId) => {
    try {
      const { data } = await getServiceRequestItemById(sriId);
      // console.log("datadata", data);

      this.onViewServiceRequestItem = data;

      return data;
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy dữ liệu chỉ định thực hiện");
    }
  };

  calculateMinutes = (start, end) => {
    if (!start || !end) return 0;
    const startDate = new Date(start);
    const endDate = new Date(end);
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return 0;

    const diffMs = endDate.getTime() - startDate.getTime();
    return Math.max(0, Math.floor(diffMs / (1000 * 60)));
  };

  formatResultsServiceRequestItems = (data) => {
    return data?.results?.reduce((acc, item, index) => {
      const duration =
        item?.requestItemStep?.serviceStep?.executionDurationOfStep || 0;

      const performedDate =
        index === 0 ? new Date() : acc[index - 1]?.performedDateEnd;

      const performedDateEnd = moment(performedDate).add(duration, "minutes");

      acc.push({
        ...item,
        performedDate,
        performer: item?.requestItemStep?.performer,
        numberOfMinutes: duration,
        performedDateEnd,
      });

      return acc;
    }, []);
  };

  startTreatment = async (serviceRequestItemId) => {
    try {
      const { data } = await getOrCreateNewByServiceRequestItemId(
        serviceRequestItemId
      );
      if (data?.responseStatus === false) {
        setTimeout(() => {
          if (data?.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = data?.responseDetail;
          } else {
            this.openConfirmMessage = data?.responseDetail;
          }
        }, 500);
        return false;
      }
      if (data?.result) {
        const results = this.formatResultsServiceRequestItems(data);
        console.log("results", results);

        this.receiveTreatmentResult = { ...data, results };
      }

      return data;
    } catch (error) {
      // const { data } = await getOrCreateNewByServiceRequestItemId(serviceRequestItemId);
      // this.receiveTreatmentResult = data;
      toast.error("Có lỗi xảy ra khi lấy kết quả điều trị");
    }
  };

  handleReceiveTreatmentResult = async (serviceRequestItemId) => {
    console.log(
      "🚀 ~ ReceiveTreatmentStore ~ handleReceiveTreatmentResult= ~ serviceRequestItemId:",
      serviceRequestItemId
    );
    try {
      let data = null;

      try {
        const response = await getByServiceRequestItemId(serviceRequestItemId);
        data = response?.data;

        if (data?.id) {
          const results = this.formatResultsServiceRequestItems(data);
          // console.log("results", results);
          this.receiveTreatmentResult = { ...data, results };
          console.log(
            "🚀 ~ ReceiveTreatmentStore ~ handleReceiveTreatmentResult= ~ receiveTreatmentResult:",
            this.receiveTreatmentResult
          );
        } else {
          this.receiveTreatmentResult = null;
        }
      } catch (error) {
        console.error(error);
      }

      return data;
    } catch (error) {
      toast.error("Có lỗi xảy ra khi lấy kết quả điều trị");
    }
  };

  handleSaveDiagnosticReportByServiceRequestItem = async (values) => {
    try {
      const { data } = await saveDiagnosticReportByServiceRequestItem(values);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          if (data?.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = data?.responseDetail;
          } else {
            this.openConfirmMessage = data?.responseDetail;
          }
        }, 500);
        return;
      }
      toast.success("Cập nhật kết quả điều trị thành công");
      this.handleClose();

      return data;
    } catch (error) {
      toast.error("Có lỗi xảy ra khi lưu dữ liệu, vui lòng thử lại sau");
    }
  };

  handleSaveDiagnosticReportWithMaterialStandards = async (values) => {
    try {
      const { data } = await saveDiagnosticReportWithMaterialStandards(values);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          if (data?.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = data?.responseDetail;
          } else {
            this.openConfirmMessage = data?.responseDetail;
          }
        }, 500);
        return;
      }
      toast.success("Cập nhật định mức thành công");
      this.handleClose();

      return data;
    } catch (error) {
      toast.error("Có lỗi xảy ra khi lưu dữ liệu, vui lòng thử lại sau");
    }
  };

  handleConfirmComplete = async (id) => {
    try {
      const { data } = await markServiceAsCompletedByServiceRequestItem(id);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          if (data?.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = data?.responseDetail;
          } else {
            this.openConfirmMessage = data?.responseDetail;
          }
        }, 500);
        return;
      }
      toast.success("Đã cập nhật trạng thái của dịch vụ là Đã hoàn thành");

      return data;
    } catch (error) {
      toast.error("Có lỗi sảy ra khi cập nhận trạng thái điều trị");
    } finally {
      this.handleClose();
    }
  };

  handleOpenConfirmComplete = () => {
    this.openConfirmComplete = true;
  };

  handleOpenConfirmCompleteList = () => {
    this.openConfirmCompleteList = true;
  };

  handleCloseConfirmCompleteList = () => {
    this.openConfirmCompleteList = false;
  };

  handleConfirmCompleteList = async () => {
    try {
      const idList = this.getSelectedTreatmentIds();
      const { data } = await markMultipleServiceAsCompletedByServiceRequestItem(
        idList
      );
      const failures = data?.filter((item) => item?.responseStatus === false);
      if (failures?.length > 0) {
        setTimeout(() => {
          if (failures[0]?.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = failures[0]?.responseDetail;
          } else {
            this.openConfirmMessage = failures[0]?.responseDetail;
          }
        }, 500);
      } else {
        toast.success("Cập nhật trạng thái điều trị thành công");
      }

      return data;
    } catch (error) {
      toast.error("Có lỗi sảy ra khi cập nhận trạng thái điều trị");
    } finally {
      await this.pagingTreatments();
      this.resetSelectedRows = !this.resetSelectedRows;
      this.handleClose();
    }
  };

  getSelectedTreatmentIds = () => {
    const ids = [];

    this.listChosen?.forEach(function (item) {
      if (item?.itemStatus !== 4) {
        ids.push(item?.id);
      }
    });

    return ids;
  };

  handleGetDiagnosticReportWithMaterialStandardsBySriId = async (id) => {
    try {
      const { data } = await getDiagnosticReportWithMaterialStandardsBySriId(
        id
      );

      this.diagnosticReportMaterialStandard = {
        ...data,
        service: this?.onViewServiceRequestItem?.service,
      };

      return data;
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy dữ liệu chỉ định thực hiện");
    }
  };

  setSelectedFiles = (list) => {
    this.selectedFiles = list;
  };
  setStepId = (id) => {
    this.stepId = id;
  };
  handleUploadMultiple = async (files) => {
    try {
      const uploadResponses = await Promise.all(
        files.map((file) => uploadFile(file))
      );

      const fileIds = uploadResponses.map((res) => res?.data?.id);

      if (!fileIds.length)
        throw new Error("Không có file nào upload thành công!");

      const fileInfoResponses = await Promise.all(
        fileIds.map((id) => getFileById(id))
      );

      const imageFiles = fileInfoResponses.map((res, ind) => ({
        path: res?.data,
        id: fileIds?.[ind],
      }));

      return imageFiles;
    } catch (err) {
      console.error("Lỗi trong quá trình upload nhiều ảnh:", err);
    }
  };

  handleSetShouldUploadFileResult = (state) => {
    this.shouldUploadFileResult = state;
  };

  handleSetShouldListImageStep = (state) => {
    this.shouldListImageStep = state;
    this.handleGetDiagnosticResultWithImages(this.stepId);
  };

  handleSaveDiagnosticReportImages = async (values) => {
    try {
      const { data } = await saveDiagnosticReportImages(values);
      toast.success("Thêm mới ảnh kết quả điều trị thành công");
      this.handleClose();

      return data;
    } catch (error) {
      toast.error("Có lỗi xảy ra khi lưu dữ liệu, vui lòng thử lại sau");
    }
  };

  handleSaveDiagnosticResultImages = async (values) => {
    try {
      const { data } = await saveDiagnosticResultImages(values);
      toast.success("Thêm mới ảnh kết quả điều trị từng bước thành công");
      this.handleClose();

      return data;
    } catch (error) {
      toast.error("Có lỗi xảy ra khi lưu dữ liệu, vui lòng thử lại sau");
    }
  };

  handleGetDiagnosticReportWithImages = async (id) => {
    try {
      const { data } = await getDiagnosticReportWithImages(id);

      const formatItems = await Promise.all(
        (data.reportImages || []).map(async (item) => {
          const response = await getFileById(item?.fileDescription?.id);

          // Convert blob to object URL for image display
          const imageUrl = URL.createObjectURL(
            new Blob([response.data], { type: "image/png" })
          );

          return {
            data: item,
            src: imageUrl,
            thumb: imageUrl,
            alt: item?.name,
          };
        })
      );

      this.receiveTreatmentResult = {
        ...data,
        ...this.receiveTreatmentResult,
        reportImagesFormat: formatItems,
      };

      return this.receiveTreatmentResult;
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy dữ liệu chỉ định thực hiện");
    }
  };

  handleGetDiagnosticResultWithImages = async (id) => {
    try {
      const { data } = await getDiagnosticResultWithImages(id);

      const formatItems = await Promise.all(
        (data.reportImages || []).map(async (item) => {
          const response = await getFileById(item?.fileDescription?.id);

          // Convert blob to object URL for image display
          const imageUrl = URL.createObjectURL(
            new Blob([response.data], { type: "image/png" })
          );

          return {
            src: imageUrl,
            thumb: imageUrl,
            alt: item?.name,
          };
        })
      );
      this.listImageStep = formatItems;

      return this.listImageStep;
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy dữ liệu chỉ định thực hiện");
    }
  };

  handleGetPatientOverviewById = async (id) => {
    getPatientInfo(id)
      .then(async ({ data }) => {
        if (data?.patientAvatarId) {
          let objImg = await getFileById(data?.patientAvatarId);

          let patientAvatarId = data?.patientAvatarId;

          this.initialPatient = {
            ...data,
            patientInfo: { ...data, patientAvatarId },
            avatar: URL.createObjectURL(objImg?.data),
          };
          return;
        }

        this.initialPatient = {
          patientInfo: { ...data },
        };
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy thông tin có lỗi!");
      });
  };

  initialPatientData = async (id) => {
    try {
      if (!id) return;
      const currentServiceRequestItem = await this.getOnViewServiceRequestItem(
        id
      );

      if (
        currentServiceRequestItem?.itemStatus !== 3 &&
        currentServiceRequestItem?.itemStatus !== 4
      ) {
        toast.info("Chưa bắt đầu điều trị cho khách hàng");
      }

      if (currentServiceRequestItem?.encounter?.patientId) {
        this.handleGetPatientOverviewById(
          currentServiceRequestItem?.encounter?.patientId
        );
      }
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy dữ liệu bệnh nhân");
    }
  };

  handleStartTreatment = async (serviceRequestItemId) => {
    if (!serviceRequestItemId) return;

    await this.startTreatment(serviceRequestItemId);

    let data = await this.getOnViewServiceRequestItem(serviceRequestItemId);

    await this.initialScreenTab(serviceRequestItemId);

    toast.info("Bắt đầu điều trị");

    return data;
  };

  handleOpenConfimrUndoStartTreatment = () => {
    this.openConfirmUndoStartTreatment = true;
  };

  handleUndoStartTreatment = async (serviceRequestItemId) => {
    try {
      const { data: response } =
        await undoCreateNewDiagnosticReportByServiceRequestItemId(
          serviceRequestItemId
        );

      if (response?.[0]?.responseStatus === false) {
        setTimeout(() => {
          if (response?.[0]?.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = response?.[0]?.responseDetail;
          } else {
            this.openConfirmMessage = response?.[0]?.responseDetail;
          }
        }, 500);
      } else {
        let data = await this.getOnViewServiceRequestItem(serviceRequestItemId);

        await this.initialScreenTab(serviceRequestItemId);

        toast.success("Đã hủy điều trị");

        this.handleClose();
      }

      return response;
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi hủy điểu trị, vui lòng thử lại sau");
    }
  };

  openConfirmUndoCompletedTreatment = false;

  handleOpenConfimrUndoCompletedTreatment = () => {
    this.openConfirmUndoCompletedTreatment = true;
  };

  handleUndoCompletedTreatment = async (serviceRequestItemId) => {
    try {
      const { data: response } =
        await undoMarkServiceAsCompletedByServiceRequestItem(
          serviceRequestItemId
        );

      if (response?.responseStatus === false) {
        setTimeout(() => {
          if (response?.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = response?.responseDetail;
          } else {
            this.openConfirmMessage = response?.responseDetail;
          }
        }, 500);
      } else {
        // let data = await this.getOnViewServiceRequestItem(serviceRequestItemId);

        // await this.initialScreenTab(serviceRequestItemId);

        toast.success("Đã hủy đánh dấu hoàn thành");

        this.handleClose();
        this.openConfirmMessage = null;
        this.permissionErrorMessage = null;
      }

      return response;
    } catch (error) {
      console.error(error);
      toast.error(
        "Có lỗi xảy ra khi ấn hoàn thành điều trị, vui lòng thử lại sau"
      );
    }
  };

  initialScreenTab = async (id) => {
    const onViewServiceRequestItem = this?.onViewServiceRequestItem;

    // console.log("onViewServiceRequestItem", onViewServiceRequestItem);

    const isUnstartedTreatment =
      onViewServiceRequestItem?.itemStatus !=
      LAServiceRequestItemStatusEnum.PROCESSING.value &&
      onViewServiceRequestItem?.itemStatus !=
      LAServiceRequestItemStatusEnum.FINISHED.value;

    if (!id || isUnstartedTreatment) return;

    // console.log("catched")

    if (this.currentTab == 0) {
      await this.handleReceiveTreatmentResult(id);
    } else if (this.currentTab === 1) {
      await this.handleGetDiagnosticReportWithMaterialStandardsBySriId(id);
    } else if (this.currentTab === 2) {
      await this.handleGetDiagnosticReportWithImages(
        this.receiveTreatmentResult?.id
      );
    }
  };

  resetPatientStore = () => {
    this.initialPatient = {
      ...DEFAULT_VALUE_PATIENT,
    };
  };
}
